// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fypy","delete":"styles_delete__3PuKf","update":"styles_update__2R6Ld","add":"styles_add__3t_rA"};